/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the NotifyApiConfiguration configuration object with a given root URL.
 */
export function provideNotifyApiConfiguration(rootUrl: string) {
  var config = new NotifyApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: NotifyApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class NotifyApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `NotifyModule.forRoot()`
 */
export interface NotifyApiConfigurationParams {
  rootUrl?: string;
}
